import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Help.css";
import SearchInput from "../common/search-input/SearchInput";
import { useDispatch, useSelector } from "react-redux";

const Help = () => {
  const navigate = useNavigate();

  const [allServices, setAllServices] = useState([]);
  const [displayedServices, setDisplayedServices] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  // New State for Dynamic Tabs
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState("");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 12;
  const [totalPages, setTotalPages] = useState(1);

  const [animatedCards, setAnimatedCards] = useState(new Set());

  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const STORAGE_URL = process.env.REACT_APP_URL;

  // Filter + paginate logic
  useEffect(() => {
    if (allServices.length > 0) {
      const filtered = allServices.filter((service) => {
        const matchesSearch =
          service.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          service.description.toLowerCase().includes(searchQuery.toLowerCase());

        // Match based on dynamic activeTab
        const matchesTab = activeTab ? service.type === activeTab : true;

        return matchesSearch && matchesTab;
      });

      const pages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
      setTotalPages(pages || 1);

      if (currentPage > pages) setCurrentPage(1);

      const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
      const paginated = filtered.slice(startIndex, startIndex + ITEMS_PER_PAGE);

      setDisplayedServices(paginated);
      triggerCardAnimation(paginated);
    }
  }, [searchQuery, allServices, currentPage, activeTab]);

  const triggerCardAnimation = (services) => {
    const newAnimatedCards = new Set();
    services.forEach((service) => newAnimatedCards.add(service.id));
    setAnimatedCards(newAnimatedCards);

    setTimeout(() => setAnimatedCards(new Set()), 600);
  };

  const { data, loading, error } = useSelector((state) => state.helpService);

  const [services, setServices] = useState([]);

  // ✅ API CALL

  // ✅ YOUR ORIGINAL LOGIC (moved here)
  useEffect(() => {
    if (!data || data.length === 0) return;

    const mappedServices = data.map((service) => ({
      id: service.id.toString(),
      title: service.title,
      description: service.desc,
      status: service.status,
      type: service.type,
      icon: `${STORAGE_URL}${service.image_url}`,
      siteUrl: service.link,
    }));

    const activeServices = mappedServices.filter(
      (service) => service.status !== "inactive",
    );

    setServices(activeServices);
    setAllServices(activeServices); // ← FIXED: was missing this line

    const uniqueTypes = [...new Set(activeServices.map((s) => s.type))];

    setTabs(uniqueTypes);

    if (uniqueTypes.length > 0) {
      setActiveTab(uniqueTypes[0]);
    }
  }, [data, STORAGE_URL]); // ← FIXED: added STORAGE_URL dependency

  const handleCardClick = (siteUrl, cardId) => {
    setAnimatedCards((prev) => new Set(prev).add(cardId));

    setTimeout(() => {
      setAnimatedCards((prev) => {
        const s = new Set(prev);
        s.delete(cardId);
        return s;
      });
    }, 300);

    if (siteUrl) window.open(siteUrl, "_blank", "noopener,noreferrer");
  };

  const changePage = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const onChangeSearchInput = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  // Helper to format tab names (e.g., bank_login -> Bank Login)
  const formatTabName = (name) => {
    return name.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  return (
    <div className="help-container">
      <main className="help-main">
        <SearchInput
          onChange={onChangeSearchInput}
          value={searchQuery}
          placeholder="Search Help Services"
        />

        {/* Dynamic Tabs Section */}
        <div className="services-tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`services-tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => {
                setActiveTab(tab);
                setCurrentPage(1);
              }}
            >
              {formatTabName(tab)}
            </button>
          ))}
        </div>

        {/* Grid Section */}
        <section className="help-services-section">
          {loading ? (
            <div className="help-loading">
              <div className="help-loading-spinner"></div>
              <p>Loading services...</p>
            </div>
          ) : error ? (
            <div className="help-error">{error}</div>
          ) : (
            <>
              <div className="help-services-grid">
                {displayedServices.length === 0 ? (
                  <div className="help-no-results">
                    <span className="help-no-results-icon">🔍</span>
                    <h3>No Product Found</h3>
                    <p>Try changing your search or filters</p>
                  </div>
                ) : (
                  displayedServices.map((service, index) => (
                    <div
                      key={service.id}
                      className={`help-service-card-wrapper ${animatedCards.has(service.id) ? "card-entrance" : ""}`}
                      style={{ animationDelay: `${index * 0.05}s` }}
                    >
                      <div
                        className={`help-service-card ${animatedCards.has(service.id) ? "clicked" : ""}`}
                        style={{ backgroundImage: `url(${service.icon})` }}
                        onClick={() =>
                          handleCardClick(service.siteUrl, service.id)
                        }
                      />
                      <div className="help-service-info">
                        <h3 className="help-service-title">{service.title}</h3>
                        <p className="help-service-desc">
                          {service.description}
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="help-pagination">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => changePage(currentPage - 1)}
                  >
                    Prev
                  </button>

                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i}
                      className={`button-counter ${currentPage === i + 1 ? "active" : ""}`}
                      onClick={() => changePage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => changePage(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          )}
        </section>
      </main>
    </div>
  );
};

export default Help;
